export const GRAPHQL_VARIABLES = {
  record: {
    email: 'john.sun@bookipi.com',
    phone: '0411222333',
    firstName: 'John2',
    lastName: 'Sun',
    companyName: "John's Company",
    address: {
      address1: 'addr line1',
      address2: 'addr line2',
      address3: '',
      state: 'NSW',
      city: 'Sydney',
      zip: '2010',
      country: 'Australia'
    }
  }
};

export const QUERY = `
  mutation customersCreateOne ($record: AutoFilledCreateOnecustomersInput!) {
    customersCreateOne (record: $record) {
        recordId
        record {
            email
            phone
            firstName
            lastName
            companyName
            address {
                address1
                address2
                address3
                state
                city
                zip
                country
                _id
            }
            companyId
            bkUser
            bkCompany
            _id
            updatedAt
            createdAt
        }
        error {
            message
        }
    }
  }
`;
